import { render } from "./EntityBlank.vue?vue&type=template&id=2070a02f&ts=true"
import script from "./EntityBlank.vue?vue&type=script&lang=ts"
export * from "./EntityBlank.vue?vue&type=script&lang=ts"

import "./EntityBlank.vue?vue&type=style&index=0&id=2070a02f&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__